<template>
    <div class="portlet">
        <div class="portlet-title">
            <div class="caption text-success">Mapa do site</div>
        </div>
        <div class="">
            <div class="field-item even">
                    <div class="" v-for="item in dadosmenu">
                        <ul class="listmapasite">
                            <li>
                                <a class="titmenumapa" v-link="item.href" v-if="item.href != undefined && item.href != '' && item.linkexterno != true">{{item.titulo}}</a>
                                <a class="titmenumapa" :href="item.href" target="_blank" v-if="item.linkexterno == true">{{item.titulo}}</a>
                                <span class="titmenumapa" v-if="item.href == undefined || item.href == ''">{{item.titulo}}</span>
                                <ul v-if="item.children != undefined && item.children != ''">
                                    <li v-for="subitem in item.children">
                                        <a class="titmenumapa" :href="subitem.href" target="_blank" v-if="subitem.linkexterno == true">{{subitem.titulo}}</a>
                                        <a v-link="subitem.href" v-if="subitem.href != undefined && subitem.href != '' && subitem.linkexterno != true">{{subitem.titulo}}</a>
                                        <span v-if="subitem.href == undefined || subitem.href == ''">{{subitem.titulo}}</span>
                                        <ul v-if="subitem.children != undefined && subitem.children != ''">
                                            <li v-for="subitem2 in subitem.children">
                                                <a class="titmenumapa" :href="subitem2.href" target="_blank" v-if="subitem2.linkexterno == true">{{subitem2.titulo}}</a>
                                                <a v-link="subitem2.href" v-if="subitem2.href != undefined && subitem2.href != '' && subitem2.linkexterno != true">{{subitem2.titulo}}</a>
                                                <span v-if="subitem2.href == undefined || subitem2.href == ''">{{subitem2.titulo}}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
            </div>
        </div>
    </div>
    <!-- END FORM-->
</template>
<script>
export default{
    data() {
        return{
            dadosmenu: ''
        }
    },
    components: {
    },
    computed: {
        // criação da função que pega os dados da rota ativa
    },
    ready() {
        // console.log($('.v-link-active span.title').html());
        this.listamenu()
    },
    methods: {
        listamenu () {
             this.dadosmenu = window.menuJson
             console.log(this.dadosmenu)
        }
    },
    route: {
    }
}


</script>
<style>
    ul.listmapasite {
        padding-left: 0px;
        margin-bottom: 1.5rem;
    }
    
    ul.listmapasite li{
        list-style: none;
        font-weight: 400;
    }
    
    ul.listmapasite li ul{
        padding-left: 20px;
    }
    
    .titmenumapa{
        font-size: 14px;
        font-weight: 500;
    }
</style>


// WEBPACK FOOTER //
// mapa.vue?3b8e5793